import { DELETE_STAFF_CARDS_START } from '../../types';

export const delete_staff_cards = (payload) => ({
  type: DELETE_STAFF_CARDS_START,
  payload,
});
